import "../../CSS/ComponentCSS/LoadingBar.css";
import { Typography } from "antd";

const { Title } = Typography;

const Loading = () => {
  return (
    <div className="background">
      <Title level={4} style={{ marginBottom: "0px" }}>
        잠시만 기다려주세요.
      </Title>
      <img src="/icon/Spinner.gif" alt="로딩" width="10%" />
    </div>
  );
};

export default Loading;
